import React from 'react';
import { Trans } from '@lingui/react';

export default {
    Copy: <Trans>Copy</Trans>,
    MoveText: 'Move - the student will move from their current class and group to the new class/group',
    CopyText: 'Copy - the student will remain in their current/original class and the new class/group'
};



// WEBPACK FOOTER //
// ./components/action-button/action-button-text.js